/**
 * 路由索引
 * 包含所有带有code属性的路由配置
 */
import { CiCircleFilled } from "@ant-design/icons";
import { history } from "@umijs/max";
import routerPaths from "../../config/routes";
export const useRou = () => { 
  const menuLists = () => {
    const menus:any = {};
    routerPaths.forEach((item: any) => {
      if (item.code) {
        menus[item.code] = {
          path: item.path,
          name: item.name,
          code: item.code,
          icon: item.icon,
        };
        if (item.routes) {
          item.routes.forEach((child: any) => {
            menus[child.code] = {
              path: child.path,
              name: child.name,
              code: child.code,
              icon: child.icon,
            };
          });
        }
      }
    });
    return menus;
  };
  const getDeepCode = (menuList: any) => {
    let code: any = null; 
    if (menuList && menuList.length > 0) {
      code = menuList[0].code;
      if (menuList[0].children && menuList[0].children.length > 0) {
        code = getDeepCode(menuList[0].children);
      }
    }
    return code;
  }
  const getHome = () => {
    return new Promise((resolve) => {
      const menus = menuLists();
      setTimeout(() => {
        const menuList: any = JSON.parse(
          localStorage.getItem("menuList") || "[]"
        ); 
        let code: any = getDeepCode(menuList); 
        resolve(menus[code]); 
      }, 50);
    });
  };
  //整理codes
  const getFlatCodes = (menus: any) => {
    let codes: string[] = [];
    for (const key in menus) {
      if (menus[key].code) {
        codes.push(menus[key].code);
      }
      if (menus[key].children && menus[key].children.length > 0) {
        codes.push(...getFlatCodes(menus[key].children));
      }
    }
    return codes;
  }
  //获取最外层codes
  const getTopFlatCodes = () => { 
    const menuList: any = JSON.parse(localStorage.getItem("menuList") || "[]");
    return menuList.map((item:any)=>item.code);
  }
  const getHasMenu = (menuReal: any) => {
    //获取有效codes
    const menuList: any = JSON.parse(localStorage.getItem("menuList") || "[]");
    let codes: string[] = getFlatCodes(menuList); 
    //过滤有效菜单
    
    const menuListNew = menuReal.filter((item: any) => {
      let op = true;
      if(item.code=='re_data_report' || item.code=='residential_clear'){
        op = codes.includes('data_report')
      }
      return (op && codes.includes(item.code)) || typeof item.code == "undefined";
    }); 
    menuListNew.map((item: any) => {
      if (item.children && item.children.length > 0) {
        item.children = item.children.filter((child: any) => {
          return codes.includes(child.code) || typeof child.code == "undefined";
        });
      }
    });  
    return menuListNew;
  };
  const logout = () => {
    localStorage.removeItem("accountToken");
    localStorage.removeItem("currentUser");
    localStorage.removeItem("menuList");
    localStorage.removeItem("sonicToken");
    history.push("/user/login");
  };
  const hasAi = () => {
    const menuList: any = JSON.parse(localStorage.getItem("menuList") || "[]");
    const aiMenu = menuList.filter((item: any) => item.code == "ai");
    return aiMenu.length > 0;
  };
  return {
    getHome,
    logout,
    getHasMenu,
    getTopFlatCodes,
    hasAi,
  };
};
